import { DropAreaTypeCheckComponentBox } from './modulo_compartido/drag_expo/type-check/drop-area-type-check/drop-area-type-check.component';
import { CorreoModule } from './modulo_compartido/correo/correo.module';
import { DetalleModule } from './modulo_compartido/detalle_liquidacion/detalle.module';
import { MensajeModule } from './modulo_compartido/mensaje/mensaje.module';
import { ArvModule } from './modulo_compartido/arv/arv.module';

import { DropService } from './drags/type-check/drop-area-type-check/drop.service';
import { GenericBoxModule } from './drags/generic-box/generic-box.module';
import { BrowserModule } from '@angular/platform-browser';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Body, DateFormatPipe, SafeHtmlPipe } from './cse.body';
import { AppRoutingModule } from './cse.routing';
import { LoginComponent } from './view/login/login.component';
import { MenuComponent } from './view/menu/menu.component';
import { InicioComponent } from './component/inicio.component';
import { SidebarComponent } from './view/sidebar/sidebar.component';
import { MainComponent, pointD } from './component/main.component';
import { ImpoComponent } from './view/impo/impo.component';
import { ExpoComponent } from './view/expo/expo.component';

import { DashboardComponent } from './component/dashboard.component';

import { AuthGuard } from './services/auth-guard.service';
import { LoginService } from './view/login/login.service';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//import { LOCALE_ID } from '@angular/core';
import { CalendarModule, AutoCompleteModule, ChartModule } from 'primeng/primeng';

import { DragDropDirectiveModule } from "angular4-drag-drop";

import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';


import { DropAreaTypeCheckComponent } from './drags/type-check/drop-area-type-check/drop-area-type-check.component';
import { NavigationTypeCheckComponent } from './drags/type-check/navigation-type-check/navigation-type-check.component';
import { VisorModule } from 'app/modulo_compartido/pdf-viewer/visor.module';
import { BreadcrumbModule } from 'app/modulo_compartido/breadcrumb/breadcrumb.module';
import { GenericBoxModuleExpo } from 'app/modulo_compartido/drag_expo/generic-box/generic-box-expo.module';
import { NavigationTypeCheckComponentBox } from 'app/modulo_compartido/drag_expo/type-check/navigation-type-check/navigation-type-check.component';
import { DropExpoService } from 'app/modulo_compartido/drag_expo/type-check/drop-area-type-check/dropExpo.service';

import { Loader } from 'app/loader/oh.loader';

registerLocaleData(localeEs)

import { HttpClientModule } from '@angular/common/http';
import { Foot } from './foot/tis.foot';

import { CSECoreService } from './cse.coreService';


@NgModule({
	declarations: [
		Body,
		LoginComponent,
		MenuComponent,
		InicioComponent,
		SidebarComponent,
		DashboardComponent,
		MainComponent,
		ImpoComponent,
		ExpoComponent,

		DropAreaTypeCheckComponent,
		NavigationTypeCheckComponent,

		DropAreaTypeCheckComponentBox,
		NavigationTypeCheckComponentBox,


		DateFormatPipe,
		SafeHtmlPipe,
		pointD,
		Loader,
		Foot
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		CalendarModule,
		ChartModule,
		AutoCompleteModule,
		FormsModule,
		AppRoutingModule,
		HttpModule,
		ReactiveFormsModule,

		GenericBoxModule,

		DragDropDirectiveModule,
		ArvModule,
		MensajeModule,
		DetalleModule,
		VisorModule,
		CorreoModule,
		BreadcrumbModule,

		GenericBoxModuleExpo,
		HttpClientModule
	],
	exports: [
		pointD
	],
	providers: [AuthGuard, LoginService, DropService, DropExpoService, CSECoreService, pointD, { provide: LOCALE_ID, useValue: "es-PE" }],
	bootstrap: [Body]
})

export class CSEModule {
}



// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/cse.module.ts